
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/cancellation",
      function () {
        return require("private-next-pages/policy/cancellation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/cancellation"])
      });
    }
  